import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { ApifonConfigurationState } from '../reducers/apifon-configuration.reducer';
import * as selectors from '../selectors/apifon-configuration.selectors';

@Injectable()
export class ApifonConfigurationFacadeService extends FacadeService {
  constructor(public override store: Store<ApifonConfigurationState>) {
    super(store);
  }

  // OBSERVABLES

  configurationTypeApifon$ = this.storeSelect(selectors.getConfigurationTypeApifon);
  nameApifon$ = this.storeSelect(selectors.getNameApifon);
  statusApifon$ = this.storeSelect(selectors.getStatusApifon);
  smsSenderApifon$ = this.storeSelect(selectors.getSmsSenderApifon);
  viberSenderApifon$ = this.storeSelect(selectors.getViberSenderApifon);
  apiKeyApifon$ = this.storeSelect(selectors.getApiKeyApifon);
  tokenApifon$ = this.storeSelect(selectors.getTokenApifon);
  isSelectedConfig$ = this.storeSelect(selectors.getIsSelectedConfig);
  isSelectedConfigViberSms$ = this.storeSelect(selectors.getIsSelectedConfigViberSms);
  showUpdateBtn$ = this.storeSelect(selectors.getShowUpdateBtn);
  disableNameValue$ = this.storeSelect(selectors.getDisableNameValue);
  integrationConfigurationHelpTextStatus$ = this.storeSelect(selectors.getIntegrationConfigurationHelpTextStatus);
  credentialsConfigurationHelpTextStatus$ = this.storeSelect(selectors.getCredentialsConfigurationHelpTextStatus);
  campaignReportingHelpTextStatus$ = this.storeSelect(selectors.getCampaignReportingHelpTextStatus);
  lookBackDaysApifon$ = this.storeSelect(selectors.getLookBackDaysApifon);
  selectedApifonDataFromGrid$ = this.storeSelect(selectors.getSelectedApifonDataFromGrid);
  showCancelBtn$ = this.storeSelect(selectors.getShowCancelBtn);
  apifonDataAreValid$ = this.storeSelect(selectors.getApifonDataAreValid);
  showNameErrorMsg$ = this.storeSelect(selectors.getShowNameErrorMsg);
  showSmsSenderErrorMsg$ = this.storeSelect(selectors.getShowSmsSenderErrorMsg);
  showViberSenderErrorMsg$ = this.storeSelect(selectors.getShowViberSenderErrorMsg);
  showApiKeyErrorMsg$ = this.storeSelect(selectors.getShowApiKeyErrorMsg);
  showApiTokenErrorMsg$ = this.storeSelect(selectors.getShowApiTokenErrorMsg);
  showLookBackDaysErrorMsg$ = this.storeSelect(selectors.getShowLookBackDaysErrorMsg);

  // OBSERVABLE'S VALUES

  get configurationTypeApifon() {
    return this.storeSnapshot(this.configurationTypeApifon$);
  }

  get nameApifon() {
    return this.storeSnapshot(this.nameApifon$);
  }

  get statusApifon() {
    return this.storeSnapshot(this.statusApifon$);
  }

  get smsSenderApifon() {
    return this.storeSnapshot(this.smsSenderApifon$);
  }

  get viberSenderApifon() {
    return this.storeSnapshot(this.viberSenderApifon$);
  }

  get apiKeyApifon() {
    return this.storeSnapshot(this.apiKeyApifon$);
  }

  get tokenApifon() {
    return this.storeSnapshot(this.tokenApifon$);
  }

  get isSelectedConfig() {
    return this.storeSnapshot(this.isSelectedConfig$);
  }

  get showUpdateBtn() {
    return this.storeSnapshot(this.showUpdateBtn$);
  }

  get lookBackDaysApifon() {
    return this.storeSnapshot(this.lookBackDaysApifon$);
  }

  get selectedApifonDataFromGrid() {
    return this.storeSnapshot(this.selectedApifonDataFromGrid$);
  }

  get apifonDataAreValid() {
    return this.storeSnapshot(this.apifonDataAreValid$);
  }

  getApifonBody() {
    const nameApifon = this.nameApifon;
    const configurationTypeApifon = this.configurationTypeApifon;
    const smsSenderApifon = this.smsSenderApifon;
    const viberSenderApifon = this.viberSenderApifon;
    const apiKeyApifon = this.apiKeyApifon;
    const tokenApifon = this.tokenApifon;
    const status = this.statusApifon;

    let integrationConfig;

    if (configurationTypeApifon === 'APIFON_VIBER_SMS') {
      integrationConfig = {
        integrationSystem: configurationTypeApifon,
        integrationDisplayName: nameApifon,
        reportingConfiguration: { lookbackDays: this.lookBackDaysApifon },
        viberSender: viberSenderApifon,
        smsSender: smsSenderApifon,
      };
    } else if (configurationTypeApifon === 'APIFON_SMS') {
      integrationConfig = {
        integrationSystem: configurationTypeApifon,
        integrationDisplayName: nameApifon,
        reportingConfiguration: { lookbackDays: this.lookBackDaysApifon },
        sender: smsSenderApifon,
      };
    }

    const apifonBody = {
      integrationCode: nameApifon,
      deleted: status,
      integrationConfig,
      endpointConfiguration: {
        code: nameApifon,
        endpointConfig: {
          type: 'HTTP',
          baseURL: null,
          method: null,
          requestContentType: null,
          responseContentType: null,
          readTimeOut: null,
          connectionTimeOut: null,
          dateFormat: null,
          skipSSL: false,
          queryParams: {},
          pathParams: {},
          headers: {},
        },
        credentialConfig: {
          type: 'MULTI_HEADER',
          bypassEncryption: false,
          headers: {
            API_KEY: apiKeyApifon,
            API_TOKEN: tokenApifon,
          },
        },
      },
    };

    return apifonBody;
  }
}
